module.exports = __webpack_public_path__ + "img/formula.75dacfa2.svg";